<template>
    <i class="ico-svg-chevron-left">
        <svg v-bind="{ width, height }" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M.301 10.755l9.276 8.82c.465.422 1.42.575 1.914.25.494-.327.577-1.221.195-1.652l-8.539-8.12 8.538-8.121c.407-.386.495-1.16-.194-1.687-.688-.527-1.509-.097-1.915.289L.3 9.354c-.4.383-.4 1.02.001 1.401z" :fill="color"/>
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconChevronLeft',

    props: {
        width: {
            type: Number,
            default: 12,
        },

        height: {
            type: Number,
            default: 20,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
